const __WEBPACK_NAMESPACE_OBJECT__ = require("@nackle/intl-tools");